import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, Input, Icon, TextArea, Header, Table, Dropdown, Label, Modal, Checkbox } from 'semantic-ui-react';
import i18next from 'i18next';
import api from '../../../actions/api';
import { formatPrice } from '../../../helpers/format';
import currencyOptions from '../../../consts/CommonCurrency.json';

const cancelationReasons = ['outOfStock', 'incompatibleMenu', 'unmatchingPrice', 'testing', 'other'];

class CreditOrderModal extends Component {
    defaultFormData = {
        amount: '',
        reason: '',
        remarks: '',
        payments: [],
        itemsIds: [],
        validation: null,
        notifyUser: true,
    };

    state = { ...this.defaultFormData, paymentId: (this.props.order.payments[0] || {}).id }

    validateCredit = () => {
        const { paymentId, amount } = this.state;
        api.restaurant.get(this.props.restaurant.id).orders.creditValidation(paymentId, amount)
            .then(({ data }) => {
                this.setState({
                    validation: data,
                    payments: data.paymentLogs.map((p, i) => ({ ...p, creditAmount: i ? 0 : data.amount }))
                });
            })
            .catch((error) => {

            });
    }

    handleCredit = () => {
        const { paymentId, reason, remarks, notifyUser, itemsIds } = this.state;
        const { discount } = this.state.validation;
        const credits = this.state.payments.filter(p => p.creditAmount).map(({ id, creditAmount }) => ({ id, amount: creditAmount }));

        this.props.onApprove({ paymentId, reason, remarks, notifyUser, credits, itemsIds, discount });
        this.setState({ ...this.state, ...this.defaultFormData });
    }

    handleModalClose = () => {
        this.props.onClose();
        this.setState({ ...this.state, ...this.defaultFormData });
    }

    handleItemPick(item, checked) {
        let { amount } = this.state;

        if (checked) {
            amount = this.state.itemsIds.length ? amount : 0;
            this.setState({ itemsIds: this.state.itemsIds.concat(item.id), amount: amount + item.price });
        } else {
            this.setState({ itemsIds: this.state.itemsIds.filter(id => id !== item.id), amount: amount - item.price });
        }
    }

    handleAmountChange(payment, newAmount) {
        const creditAmount = Number(newAmount);
        this.setState({ payments: this.state.payments.map(p => p.id === payment.id ? 
            ({ ...p, creditAmount: p.amount > creditAmount ? creditAmount : p.amount }) : p) });
    }

    renderAmountPicker() {
        const { order, restaurant } = this.props;
        return (
            <div>
                <Table celled padded>
                    <Table.Header fullWidth>
                        <Table.Row>
                            <Table.HeaderCell />
                            <Table.HeaderCell>{i18next.t('customer')}</Table.HeaderCell>
                            <Table.HeaderCell>{i18next.t('amount')}</Table.HeaderCell>
                            <Table.HeaderCell>{i18next.t('discount')}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {order.payments.map((payment) => {
                            return (
                                <Table.Row key={payment.id}>
                                    <Table.Cell collapsing>
                                        <Checkbox
                                            checked={this.state.paymentId === payment.id}
                                            onChange={() => this.setState({ paymentId: payment.id })}
                                        />
                                    </Table.Cell>
                                    <Table.Cell>{`${payment.name}, ${payment.phone}`}</Table.Cell>
                                    <Table.Cell>{formatPrice(payment.amount, this.props.restaurant.currencyCode, 2)}</Table.Cell>
                                    <Table.Cell>{formatPrice(payment.discount, this.props.restaurant.currencyCode, 2)}</Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>

                {!order.items.length ? null :
                    <Table celled padded>
                        <Table.Header fullWidth>
                            <Table.Row>
                                <Table.HeaderCell />
                                <Table.HeaderCell>{i18next.t('item')}</Table.HeaderCell>
                                <Table.HeaderCell>{i18next.t('price')}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {order.items.reduce((items, item) => {
                                items.push({ ...item, price: item.toppings.reduce((sum, i) => sum - i.price, item.price) });
                                return items.concat(item.toppings.map(top => ({ ...top, name: '-- ' + top.name })));
                            }, []).map((item) => {
                                return (
                                    <Table.Row key={item.id}>
                                        <Table.Cell collapsing>
                                            <Checkbox
                                                checked={this.state.itemsIds.includes(item.id)}
                                                onChange={(event, data) => this.handleItemPick(item, data.checked)}
                                            />
                                        </Table.Cell>
                                        <Table.Cell>{item.name}</Table.Cell>
                                        <Table.Cell>{formatPrice(item.price, this.props.restaurant.currencyCode, 2)}</Table.Cell>
                                    </Table.Row>
                                );
                            })}
                        </Table.Body>
                    </Table>
                }

                <Input
                    // fluid
                    label={{ basic: true, content: currencyOptions[restaurant.currencyCode || 'ILS'].symbol_native }}
                    labelPosition='right'
                    type='text'
                    placeholder={i18next.t('price')}
                    disabled={this.state.itemsIds.length > 0}
                    required
                    value={this.state.amount}
                    onChange={({ target }) => this.setState({ amount: target.value })}
                />

            </div>
        );
    }

    renderConfirmation() {
        const { restaurant } = this.props;
        const reasonOptions = cancelationReasons.map(reason =>
            ({ key: reason, text: i18next.t(`orders.cancelForm.reasons.${reason}`), value: reason }));


        return (
            <Grid padded className='pi-cancel-order-form-grid'>
                <Grid.Row className='pi-cancel-order-form-grid-row'>
                    <Table celled padded>
                        <Table.Header fullWidth>
                            <Table.Row>
                                <Table.HeaderCell>{i18next.t('customer')}</Table.HeaderCell>
                                <Table.HeaderCell>{i18next.t('paymentMethod')}</Table.HeaderCell>
                                <Table.HeaderCell>{i18next.t('amount')}</Table.HeaderCell>
                                <Table.HeaderCell>{i18next.t('amount')}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {this.state.payments.map((payment) => {
                                return (
                                    <Table.Row key={payment.id}>
                                        <Table.Cell>{payment.name}</Table.Cell>
                                        <Table.Cell>{payment.type ? payment.label + ' - ' + payment.type : i18next.t('subsidy')}</Table.Cell>
                                        <Table.Cell>{formatPrice(payment.amount, this.props.restaurant.currencyCode, 2)}</Table.Cell>
                                        <Table.Cell collapsing style={{ padding: 0, paddingLeft: 5, paddingRight: 5 }}>
                                            <input
                                                style={{ lineHeight: 2 }}
                                                value={payment.creditAmount}
                                                disabled={this.state.payments.length === 1}
                                                onChange={({ target }) =>  this.handleAmountChange(payment, target.value)}
                                            />
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            })}
                        </Table.Body>
                    </Table>
                </Grid.Row>
                <Grid.Row className='pi-cancel-order-form-grid-row pi-cancel-order-form-reason-row'>
                    <Button as='div' labelPosition='left'>
                        <Label>
                            <Icon name='question circle' />
                            {i18next.t('orders.cancelForm.cancelationReason')}
                        </Label>
                        <Dropdown button floating
                            options={reasonOptions}
                            value={this.state.reason}
                            onChange={(event, data) => this.setState({ reason: data.value })} />
                    </Button>
                </Grid.Row>
                <Grid.Row className='pi-cancel-order-form-grid-row'>
                    <Header as='h5'>{i18next.t('inDetail')}: </Header>
                    <TextArea autoHeight
                        placeholder={i18next.t('general.optional')}
                        value={this.state.remarks}
                        onChange={(event, data) => this.setState({ remarks: data.value })}
                        className='pi-cancel-order-form-details' />
                </Grid.Row>
                <Grid.Row className='pi-cancel-order-form-grid-row'>
                    <Checkbox
                        label={i18next.t('orders.cancelForm.notifyUser')}
                        checked={this.state.notifyUser}
                        onChange={(event, data) => this.setState({ notifyUser: data.checked })}
                    />
                </Grid.Row>
            </Grid >
        );
    }

    render() {
        const { isVisible } = this.props;

        return (
            <Modal dimmer='blurring'
                open={isVisible}
                onClose={this.handleModalClose}
                style={{ direction: i18next.dir() }}
                className='pi-cancel-order-form'
            >
                <Header icon='check circle' content={i18next.t('completeOrder')} />
                <Modal.Content>
                    {this.state.validation ? this.renderConfirmation() : this.renderAmountPicker()}
                </Modal.Content>
                <Modal.Actions>
                    <Button color='red' inverted onClick={this.handleModalClose} >
                        {i18next.t('cancel')}
                    </Button>
                    {!this.state.validation ?
                        <Button primary inverted onClick={this.validateCredit} >
                            {i18next.t('next')}
                        </Button>
                        :
                        <Button
                            color='green'
                            inverted
                            onClick={this.handleCredit}
                            disabled={!this.state.reason}
                        >
                            {i18next.t('yes')}
                        </Button>
                    }
                </Modal.Actions>
            </Modal>
        );
    }
}

CreditOrderModal.propTypes = {
    order: PropTypes.object,
    restaurant: PropTypes.object,
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    onApprove: PropTypes.func
    
};

export default CreditOrderModal;